import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { ValidateEmailResponse } from "@waytek/Types/AvalaraValidationModel";

export interface ValidateEmailExistsApiParameter extends ApiParameter {
    emailToCheck: string;
    properties?: { [key: string]: string };
}

const validateEmailExistsApi = "/api/v1/accountEmail/validateExist";

export function validateEmailExists(parameter: ValidateEmailExistsApiParameter) {
    return post<ValidateEmailExistsApiParameter, ValidateEmailResponse>(`${validateEmailExistsApi}`, parameter);
}
